import React, { useEffect, useRef } from 'react';
import './qrcodeRenderer.css';

interface QRCodeRendererProps {
    domId: string;
    wlId: string;
    wl_id?: string;
}

const QRCodeRenderer: React.FC<QRCodeRendererProps> = ({ domId, wlId, wl_id = 'ww92653858095c7bd4' }) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const loadingRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // 初始化二维码
        if (window.wlQrcodeNostyleComp) {
            window.wlQrcodeNostyleComp.init({
                wl_id,
                wl_qrcode_id: [wlId],
                DOMid: [domId],
            });
        }

        // 检测二维码加载完成
        let num = 0;
        const interval = setInterval(() => {
            const container = document.getElementById(domId);
            const img = container?.querySelector('img');

            if (img) {
                // 二维码加载完成，移除加载提示
                if (loadingRef.current) {
                    loadingRef.current.style.display = 'none';
                }
                clearInterval(interval);
                num = 0;
            }

            num++;
            if (num > 50) {
                // 超时清理
                clearInterval(interval);
                num = 0;
            }
        }, 100);

        return () => {
            clearInterval(interval);
        };
    }, [domId, wlId, wl_id]);

    return (
        <div ref={containerRef} id={domId} className="qrcode-renderer-container">
            <div ref={loadingRef} className="qrcode-loading">
                <svg width="32" height="32" viewBox="0 0 24 24" className="qrcode-loading-svg" strokeWidth="2">
                    <path d="M12 4v1M12 19v1M4 12h1M19 12h1M4 4l1 1M19 19l-1-1M19 4l-1 1M4 19l1-1" strokeLinecap="round" strokeLinejoin="round"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                </svg>
                <div className="qrcode-loading-text">二维码加载中</div>
            </div>
        </div>
    );
};

export default QRCodeRenderer;